<template>
  <div class="calculator__items">
    <div class="calculator__item calculator__item_address calculator__item_active">
      <template v-if="showAddressForm">
        <div class="calculator-form__fields calc3__fields" >
          <div class="calculator-field__label">
            {{ person === 'sender' ? 'Адрес отправителя' : 'Адрес получателя' }}
          </div>
          <div class="calc3__row">
            <div class="calc3__col">
              <div
                class="calculator-form__field calculator-form__field_input calculator-form__field_full-width mb-3"
              >
                <span
                  class="field-input"
                  :class="{
                    'field-item__error': validationTarget.addressStreet.$error,
                    'field-full': orderPIPTarget.addressStreet.length
                  }"
                >
                  <label>
                    <span class="label-description">Улица</span>
                    <input
                      id="recipient-street"
                      ref="recipientStreet"
                      class="field-input__inner"
                      placeholder="Улица"
                      required
                      type="text"
                      autocomplete="new-password"
                      data-type="to"
                      :value="orderPIPTarget.addressStreet"
                    >

                  </label>
                  <span
                    v-if="!validationTarget.addressStreet.required"
                    class="field__error"
                  >
                    Обязательно для заполнения
                  </span>

                  <span
                    v-if="validations && validationTarget.addressStreet.$error && !orderPIPTarget.addressStreet.length"
                    class="field__error_inv"
                  >
                    Обязательно для заполнения
                  </span>

                </span>
              </div>
              <div class="calc-3__field-small-wrap">
                <div
                  class="calculator-form__field calculator-form__field_input me-2 calc-3__field-small"
                >
                <span
                  class="field-input"
                  :class="{
                    'field-item__error': validationTarget.addressHome.$error,
                    'field-full': orderPIPTarget.addressHome.length,
                  }"
                >
                  <label>
                    <span class="label-description">Дом</span>
                    <input
                      id="recipient-home"
                      ref="recipientHome"
                      class="field-input__inner"
                      placeholder="Дом"
                      required
                      type="text"
                      data-type="to"
                      autocomplete="new-password"
                      :value="orderPIPTarget.addressHome"
                    >
                  </label>
                  <span
                    v-if="!validationTarget.addressHome.required"
                    class="field__error"
                  >
                    Введите номер дома
                  </span>
                  <span
                    v-if="validations && validationTarget.addressHome.$error && !orderPIPTarget.addressHome.length"
                    class="field__error_inv"
                  >
                    Введите номер дома
                  </span>
                </span>
                </div>
                <div
                  class="calculator-form__field calculator-form__field_input calc-3__field-small me-2"
                >
                <span
                  class="field-input"
                  :class="{
                    'field-full': orderPIPTarget.addressPorch.length,
                  }"
                >
                  <label>
                    <span class="label-description">Подъезд</span>
                    <input
                      id="recipient-porch"
                      ref="recipientPorch"
                      v-model="orderPIPTarget.addressPorch"
                      class="field-input__inner"
                      placeholder="Подъезд"
                      data-type="to"
                      type="text"
                      autocomplete="new-password"
                    >
                  </label>
                </span>
                </div>
                <div
                  class="calculator-form__field calculator-form__field_input calc-3__field-small"
                >
                <span
                  class="field-input"
                  :class="{
                    'field-item__error': addressFlatError,
                    'field-full': orderPIPTarget.addressFlat,
                  }"
                >
                  <label>
                    <span class="label-description">Кв\офис</span>
                    <input
                      id="recipient-flat"
                      ref="recipientFlat"
                      v-model="orderPIPTarget.addressFlat"
                      class="field-input__inner"
                      placeholder="Кв\офис"
                      data-type="to"
                      type="text"
                      autocomplete="new-password"
                    >
                  </label>
                  <span
                    v-if="addressFlatError"
                    class="field__error"
                  >
                    Введите номер кв\офиса
                  </span>
                  <span
                    v-if="addressFlatError"
                    class="field__error_inv"
                  >
                    Введите номер кв\офиса
                  </span>
                </span>
                </div>
              </div>
            </div>
            <div class="calc3__col">
              <div
                v-if="isMobile"
                class="calculator__checkbox my-3"
              >
              <span class="field-checkbox">
                <input
                  id="private_house_m"
                  v-model="orderPIPTarget.addressPrivateHome"
                  class="field-checkbox__input"
                  type="checkbox"
                  name="private_house"
                >
                <label
                  class="field-checkbox__label"
                  for="private_house_m"
                >
                  Частный дом
                </label>
              </span>
              </div>

              <div
                class="calculator-form__field calculator-form__field_input calculator-form__field_full-width"
              >
                <span
                  class="field-textarea"
                  :class="{'field-full': orderPIPTarget.courierDetails.length}"
                >
                  <label>
                    <span class="label-description">Комментарий для курьера</span>
                    <textarea
                      id="recipient-courierDetails"
                      ref="recipientCourierDetails"
                      v-model="orderPIPTarget.courierDetails"
                      class="field-textarea__inner"
                      cols="30"
                      rows="7"
                      placeholder="Комментарий для курьера"
                    />
                  </label>
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="!isMobile"
            class="calculator__checkbox"
          >
              <span class="field-checkbox">
                <input
                  id="private_house"
                  v-model="orderPIPTarget.addressPrivateHome"
                  class="field-checkbox__input"
                  type="checkbox"
                  name="private_house"
                >
                <label
                  class="field-checkbox__label"
                  for="private_house"
                >
                  Частный дом
                </label>
              </span>
          </div>
        </div>
      </template>
      <template v-if="!showAddressForm">
        <UiSwitcher
          v-if="showAcceptPaymentsSwitcher"
          :value="acceptReceiverPayments"
          class="calc-3__switcher"
          :disabled="loadingSwitcher"
          @input="$emit('changedAcceptReceiverPayments', $event)"
        >
          Отделения принимают оплату при получении
        </UiSwitcher>
        <div class="calculator__item-content calculator-map-content">
          <CalculatorMap
            ref="receiverCalculatorMap"
            :collection="pointsCollection"
            :person="person"
            @checkPoint="checkPoint"
            @removeCheckPoint="removeCheckPoint"
          />
        </div>
      </template>
      <div
        v-if="needReturnPoint"
        class="mt-4"
        style="width: 100%;"
      >
        <div class="calculator-field__label">
          Адрес отделения для возврата
        </div>
        <CalcCommentError class="mb-3">
          <template slot="title">
            Укажите адрес для возврата
          </template>
          В случае если получатель отказался от посылки или не смог её забрать, укажите адрес отделения, куда ее вернуть
        </CalcCommentError>
        <div
          v-if="needReturnPoint"
          class="calculator__item-content calculator-map-content calculator-map-content_return-point">
          <CalculatorMap
            ref="returnCalculatorMap"
            :collection="pointsCollectionReturn"
            :person="person"
            @checkPoint="checkPointReturn"
            @removeCheckPoint="removeCheckPointReturn"
          />
        </div>
      </div>
    </div>
    <CalcNavDesktop
      v-if="!isMobile"
      class="calc-3__calc-nav-desktop"
      :is-loading="isLoading"
      :error-text="navErrorText"
      @stepValidation="stepValidation"
      @step-back="$emit('step-back')"
    />
    <CalcNavMobile
      v-else
      :is-loading="isLoading"
      :error-text="navErrorText"
      @stepValidation="stepValidation"
      @step-back="$emit('step-back')"
    />
  </div>
</template>

<script>
/* global $ */
import CalcNavDesktop from './components/CalcNavDesktop.vue';
import CalculatorMap from '../CalculatorMap/CalculatorMap.vue';
import { COUNTRY_CODES, DELIVERY_TYPES } from '../../helpers/constans';
import { dadataApi } from '../../helpers/url';
import CalcCommentError from './components/CalcCommentError.vue';
import CalcNavMobile from './components/CalcNavMobile.vue';
import deviceInfo from '../../helpers/device';
import UiSwitcher from '../ComponentsForm/UiSwitcher.vue';
import * as odpRepository from '../../store/odp.repository';

export default {
  name: 'CalculatorPIP3rd4thStepView',
  components: {
    UiSwitcher,
    CalcNavMobile,
    CalcCommentError,
    CalcNavDesktop,
    CalculatorMap,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    orderPIP: {
      type: Object,
      required: true,
    },
    orderPIPTarget: {
      type: Object,
      required: true,
    },
    orderCalcPIP: {
      type: Object,
      required: true,
    },
    orderCalcPIPTarget: {
      type: Object,
      required: true,
    },
    pointsCollection: {
      type: Array,
      required: true,
    },
    person: {
      type: String,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    validationTarget: {
      type: Object,
      required: true,
    },
    kladr: {
      type: Object,
      required: true,
    },
    addressValid: {
      type: Object,
      required: true,
    },
    needResetReceiverFields: {
      type: Boolean,
      default: false,
    },
    needChangePoint: {
      type: Boolean,
      default: false,
    },
    pointsCollectionReturn: {
      type: Array,
      default: () => ([]),
    },
    acceptReceiverPayments: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stepError: false,
      firstRender: true,
      returnPointError: false,
      addressFlatError: false,
      loadingSwitcher: false,
    };
  },
  computed: {
    ...deviceInfo,
    showAddressForm() {
      return (this.person === 'sender')
        ? this.orderPIP.delivery_type === 1 || this.orderPIP.delivery_type === 2
        : this.orderPIP.delivery_type === 1 || this.orderPIP.delivery_type === 3;
    },
    needReturnPoint() {
      return (this.person === 'sender')
        && (this.orderPIP.delivery_type === DELIVERY_TYPES.DOOR_TO_PVZ
        || this.orderPIP.delivery_type === DELIVERY_TYPES.DOOR_TO_DOOR);
    },
    navErrorText() {
      if (this.stepError && !this.showAddressForm) return 'Пожалуйста, выберите отделение на карте';
      if (this.showAddressForm && (this.validationTarget.addressStreet.$error || this.validationTarget.addressHome.$error || this.addressFlatError)) return 'Пожалуйста, заполните все отмеченные поля';
      if (this.returnPointError && !this.orderCalcPIP.return_point) return 'Укажите отделение для случая возврата';
      return '';
    },
    showAcceptPaymentsSwitcher() {
      return this.person === 'receiver'
        && (this.orderPIP.receiver.country === COUNTRY_CODES.KAZAKHSTAN
        || this.orderPIP.receiver.country === COUNTRY_CODES.BELARUS)
        && this.orderPIP.sender.country === COUNTRY_CODES.RUSSIA;
    }
  },
  watch: {
    'orderPIPTarget.addressPrivateHome': function (val) {
      if (val) {
        this.orderPIPTarget.addressFlat = '';
        this.addressFlatError = false;
      }
    },
    'orderPIPTarget.addressFlat': function (val) {
      if (val) {
        this.orderPIPTarget.addressPrivateHome = false;
        this.addressFlatError = false;
      }
      if (!val && !this.orderPIPTarget.addressPrivateHome) {
        this.addressFlatError = true;
      }
    },
    acceptReceiverPayments: {
      handler: async function (val, oldVal) {
        if (!this.showAcceptPaymentsSwitcher) return;
        if (val === oldVal) return;
        this.loadingSwitcher = true;
        const filration = val ? ['deliveryLap', 'acceptPayments'] : ['deliveryLap'];
        const receiverCountryCode = this.person === 'receiver' ? this.orderCalcPIP.receiver.country : '';
        const result = await odpRepository.default.findInCity(this.orderCalcPIP.receiver.city, '10000', filration, receiverCountryCode);
        this.$emit('changedReceiverPoints', result.data.odp);
        this.loadingSwitcher = false;
      },
      immediate: true,
    },
  },
  beforeMount() {
    if (this.person === 'receiver' && !this.showAcceptPaymentsSwitcher && this.acceptReceiverPayments) {
      this.acceptReceiverPayments = false;
    }
  },
  mounted() {
    this.initDadataFields();

    if (!this.showAddressForm && this.$refs.receiverCalculatorMap) {
      this.$refs.receiverCalculatorMap.closeOdpPreview();
      this.$refs.receiverCalculatorMap.removeCheckPoint();
    }
    if (this.$refs.returnCalculatorMap) {
      this.$refs.returnCalculatorMap.closeOdpPreview();
      this.$refs.returnCalculatorMap.removeCheckPoint();
    }

    if (this.needResetReceiverFields) {
      this.resetReceiverFields();
      this.$emit('resetReceiverFieldsSuccess');
    }

    if (this.needChangePoint) {
      this.orderPIPTarget.point = '';
      this.$emit('changedCity');
    }
  },
  methods: {
    initDadataFields() {
      if (this.$refs.recipientStreet) {
        const self = this;
        const type = 'ADDRESS';
        const $street = $(this.$refs.recipientStreet);
        const $home = $(this.$refs.recipientHome);

        const suggestionsStreet = $street
          .suggestions({
            serviceUrl: dadataApi,
            type,
            bounds: 'settlement-street',
            geoLocation: false,
            constraints: {
              label: '',
              locations: {
                city: this.orderCalcPIPTarget.cityName,
              },
            },
            scrollOnFocus: false,
            onSelect: (suggestion) => {
              self.orderPIPTarget.addressHome = '';
              $(self.$refs.recipientHome).val('');
              if (!this.firstRender) {
                self.orderPIPTarget.addressFlat = '';
              } else {
                this.firstRender = false;
              }
              self.orderPIPTarget.addressStreet = suggestion.value;
              self.addressSelectedPIP(suggestion, $street);
            },
            onSelectNothing() {
              self.orderPIPTarget.addressHome = '';
              self.orderPIPTarget.addressStreet = '';
              self.validationTarget.addressStreet.$touch();
            },
          }).suggestions();
        suggestionsStreet.fixData();

        const suggestionsHome = $home
          .suggestions({
            serviceUrl: dadataApi,
            type: 'ADDRESS',
            hint: false,
            noSuggestionsHint: false,
            bounds: 'house',
            constraints: $street,
            scrollOnFocus: false,
            onSelect: (suggestion) => {
              self.orderPIPTarget.addressHome = suggestion.value;
              self.addressSelectedPIP(suggestion, $home);
            },
            onSelectNothing() {
              self.orderPIPTarget.addressHome = '';
              self.validationTarget.addressHome.$touch();
            },
          }).suggestions();
        suggestionsHome.fixData();
      }
    },
    addressSelectedPIP(suggestion) {
      this.orderPIPTarget.zip = suggestion.data.postal_code;
      this.orderPIPTarget.address = suggestion.unrestricted_value;
      this.orderPIPTarget.val = suggestion;
      this.addressValid.val = suggestion;
    },
    stepValidation() {
      if (!this.showAddressForm) {
        if (this.orderPIPTarget.point) {
          this.$emit('step-up');
        } else {
          this.stepError = true;
        }
      } else {
        this.stepError = false;
        this.returnPointError = false;

        const receiverAddress = this.validationTarget.addressStreet.required
          && this.validationTarget.addressHome.required
          && (this.orderPIPTarget.addressFlat || this.orderPIPTarget.addressPrivateHome);

        if (receiverAddress) {
          if (this.needReturnPoint && !this.orderCalcPIP.return_point) {
            this.returnPointError = true;
            return;
          }
          this.$emit('step-up');
        } else {
          if (!this.orderPIPTarget.addressPrivateHome && !this.orderPIPTarget.addressFlat) {
            this.addressFlatError = true;
          }
          this.$emit('someAction');
        }
      }
    },
    checkPoint(odp) {
      this.orderPIPTarget.point = odp.id;
      this.orderPIPTarget.pointAddress = odp.address;
      this.orderPIPTarget.pointTitle = odp.title;
      this.orderPIPTarget.acquiring = odp.acquiring;
      this.orderPIPTarget.cashPayment = odp.cashPayment;
      this.orderPIPTarget.pointScheduleShort = odp.scheduleShort;
      this.orderPIPTarget.pointPhone = odp.phone;
      this.orderPIPTarget.pointPhotos = odp.photos;
      this.stepError = false;
    },
    checkPointReturn(odp) {
      this.orderCalcPIP.return_point = odp.id;
    },
    removeCheckPoint() {
      this.orderPIPTarget.point = null;
      this.orderPIPTarget.pointAddress = null;
      this.orderPIPTarget.pointTitle = null;
      this.orderPIPTarget.acquiring = true;
      this.orderPIPTarget.cashPayment = true;
    },
    removeCheckPointReturn() {
      this.orderCalcPIP.return_point = null;
    },
    resetReceiverFields() {
      this.orderPIPTarget.addressStreet = '';
      this.orderPIPTarget.addressHome = '';
      this.orderPIPTarget.addressPorch = '';
      this.orderPIPTarget.addressFlat = '';
      this.orderPIPTarget.addressPrivateHome = false;
      this.orderCalcPIP.return_point = null;
    },
    citySelectedPIP(suggestion, $input) {
      if ($input) {
        $input.data('kladr', suggestion.data.city_kladr_id || suggestion.data.settlement_kladr_id);
      }
    },
    cityClearPIP() {
      this.orderCalcPIPTarget.city = '';
      this.orderPIPTarget.city = '';
      this.kladr[this.person] = '';
    },
  },
};
</script>
